import Checkbox from "components/semantic/Checkbox";
import RadioButton from "components/semantic/Radio";
import React, { FC } from "react";
import QuestionBox from "./QuestionBox";

interface HealthLifestyleProps {
  questions: any;
  padding: string;
  formProps: any;
}

const HealthLifestyle: FC<HealthLifestyleProps> = ({ questions, padding, formProps }) => {
  const { values, setFieldValue } = formProps;

  return (
    <>
      <div className="md:border md:rounded-lg md:mx-5 md:-mt-0.5 md:mb-4">
        <QuestionBox question={questions?.Question} SNo={questions?.S_No} formProps={formProps} Id={questions?.Id} />

        <div className={`${values[questions?.Id] ? "slide-down" : "slide-up"} bg-[#F4F5FA] ${padding} md:rounded-b-lg`}>
          {questions?.SubQuestion?.map((subQuestions: any, i: number) => {
            if (subQuestions?.QuestionType === "MultiSelect") {
              return (
                <div key={i} className="w-full">
                  <div className="flex gap-1 flex-col md:flex-row">
                    <p className="font-bold text-sm">{subQuestions?.Question}</p>
                    <div className="max-w-fit">{questions?.WarningMessage && <p className="font-medium text-xs text-[#9C3430] border border-[#E9C7C5] bg-[#FEEFEE] px-2 py-0.5 rounded-[4px] items-center">{questions?.WarningMessage}</p>}</div>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full gap-y-4 py-5">
                    {subQuestions?.Value?.map((subQValues: any, subIndex: number) => (
                      <Checkbox key={subIndex} label={subQValues.Option} checked={values[subQValues?.Id]} onChange={() => setFieldValue(subQValues?.Id, !values[subQValues?.Id])} />
                    ))}
                  </div>
                </div>
              );
            } else if (subQuestions?.QuestionType === "Switch") {
              return (
                <div key={i} className="w-full flex items-center py-2 border-b border-border-color overflow-x-scroll scrollbar-hide">
                  <p className="font-semibold md:font-bold text-[13px] md:text-sm min-w-[15rem] md:min-w-72 ">{subQuestions?.Question}</p>
                  <div className="bg-white rounded-[4px] px-3 md:px-6 py-3 flex gap-5">
                    <RadioButton label={"Yes"} name={true} value={values[subQuestions?.Id]} onChange={() => setFieldValue(subQuestions.Id, true)} />
                    <RadioButton label={"No"} name={false} value={values[subQuestions?.Id]} onChange={() => setFieldValue(subQuestions.Id, false)} />
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </>
  );
};
export default HealthLifestyle;
